var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatlineTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 161,
    viewBox: "0 0 158 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.0244,
    y: -36,
    width: 41,
    height: 116,
    transform: "rotate(45 22.0244 -36)",
    fill: "#DAE3EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.1016,
    y: -40.0776,
    width: 20.8189,
    height: 174.38,
    transform: "rotate(45 83.1016 -40.0776)",
    fill: "#F8F9FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7275,
    y: -23.7041,
    width: 32.115,
    height: 192.236,
    transform: "rotate(45 95.7275 -23.7041)",
    fill: "#F1F3F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137.024,
    y: -36,
    width: 29.0998,
    height: 248.318,
    transform: "rotate(45 137.024 -36)",
    fill: "#F8F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatlineTop);
export default __webpack_public_path__ + "static/media/chatlineTop.38d518084833be1f1a3f8bdaf2ba0478.svg";
export { ForwardRef as ReactComponent };